<template>
  <div id="menu">
    <ul
      id="main-menu"
      class="sm sm-blue"
      style="float: left; height: auto; width: 80%"
      data-smartmenus-id="1605583131942985"
    >
      <li class="hasSecond" v-for="(item, index) in menuItem" :key="index">
        <router-link
          :to="item.href"
          :class="{
            curent: index == parentData.MenuIndex,
            moreUlMbClick: item.isMobileClick,
          }"
        >
          <img
            v-if="index == 0"
            :src="
              parentData.MenuIndex == 0
                ? parentData.ServiceUnit === 'CY'
                  ? require(`@/assets/img/icon_haiImgCoffee.png`)
                  : require(`@/assets/img/icon_haiImgGreen.png`)
                : require(`@/assets/img/icon_haiImg.png`)
            "
            class="icon_haiImg"
          />
          {{ item.txt }}
          <span
            v-if="item.child"
            class="sub-arrow"
            @click="btnMbClick(item, index)"
          ></span>
          <ul v-if="item.child" class="moreUl sm-nowrap">
            <li v-for="(item2, index2) in item.child" :key="index2">
              <router-link :to="item2.href" @click.native="resetDefaultTime()">
                {{ item2.txt }}
                <ul
                  v-if="item2.child"
                  class="moreUlInner sm-nowrap"
                  style="width: auto; top: 0; left: 204px"
                >
                  <li v-for="(item3, index3) in item2.child" :key="index3">
                    <router-link
                      @click.native="resetDefaultTime()"
                      :to="item3.href"
                    >
                      {{ item3.txt }}
                    </router-link>
                  </li>
                </ul>
              </router-link>
            </li>
          </ul>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { GetRoleAuthorizeMenu } from "@/service/api.js";
import Timeout from "@//components/Common/Timeout.vue";
const vm = {
  name: "menuList",
  data() {
    return {
      menuItem: [],
      loginInfo: sessionStorage.getItem("LoginInfo")
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      RoleAuthorizeMenu: JSON.parse(
        sessionStorage.getItem("RoleAuthorizeMenu")
      ),
      style: {
        HomeIcon: require("@/assets/img/icon_haiImg.png"),
      },
    };
  },
  props: ["parentData"],
  created() {
    //menu選單
    // let CyMenu = [
    //   {
    //     href: "/BackStage/CY/P102",
    //     txt: "首頁",
    //   },
    //   {
    //     href: "",
    //     txt: "B申報資料",
    //     child: [
    //       { href: "/BackStage/CY/B201", txt: "B201_申報資料明細查詢" },
    //       { href: "/BackStage/CY/B202", txt: "B202_刪除申報表" },
    //       { href: "/BackStage/CY/B203", txt: "B203_保險含括聲明查詢" },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "M授權管理",
    //     child: [
    //       { href: "/BackStage/CY/M104", txt: "M104_授權時段管理" },
    //       { href: "/BackStage/CY/M201", txt: "M201_匯出授權名單" },
    //       { href: "/BackStage/CY/M205", txt: "M205_授權查調財產資料查詢" },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "S系統管理",
    //     child: [
    //       {
    //         href: "",
    //         txt: "S1代碼維護",
    //         child: [{ href: "/BackStage/CY/S101", txt: "S101_代碼維護" }],
    //       },
    //       {
    //         href: "",
    //         txt: "S2系統功能表維護",
    //         child: [
    //           { href: "/BackStage/CY/S201", txt: "S201_系統功能目錄階層維護" },
    //           { href: "/BackStage/CY/S202", txt: "S202_系統程式維護" },
    //           { href: "/BackStage/CY/S203", txt: "S203_群組維護" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "S3使用者帳號密碼維護",
    //         child: [
    //           { href: "/BackStage/CY/S301", txt: "S301_使用者帳號維護" },
    //           { href: "/BackStage/CY/S302", txt: "S302_使用者密碼變更" },
    //           // { href: "/BackStage/CY/S314", txt: "S314_服務機關資料維護" },
    //           { href: "/BackStage/CY/S315", txt: "S315_帳號資料維護" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "S4系統資訊維護",
    //         child: [
    //           { href: "/BackStage/CY/S402", txt: "S402_公告維護" },
    //           { href: "/BackStage/CY/S406", txt: "S406_常見問題維護" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "S6系統記錄查詢",
    //         child: [
    //           { href: "/BackStage/CY/S601", txt: "S601_公職人員財產申報系統登錄記錄查詢" },
    //           { href: "/BackStage/CY/S602", txt: "S602_管理平台登入記錄查詢" },
    //         ],
    //       },
    //     ],
    //   },
    // ];
    // let PdisMenu = [
    //   {
    //     href: "/BackStage/PDIS/P102",
    //     txt: "首頁",
    //   },
    //   {
    //     href: "",
    //     txt: "A申報人基本資料維護",
    //     child: [
    //       { href: "/BackStage/PDIS/A101", txt: "A101_申報人基本資料維護" },
    //       { href: "/BackStage/PDIS/A103", txt: "A103_申報人資料整批移轉" },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "B申報資料",
    //     child: [
    //       {
    //         href: "",
    //         txt: "B1申報人申報資料",
    //         child: [
    //           { href: "/BackStage/PDIS/B101", txt: "B101_申報資料明細查詢" },
    //           {
    //             href: "/BackStage/PDIS/B102",
    //             txt: "B102_申報資料紙本上傳維護",
    //           },
    //           {
    //             href: "/BackStage/PDIS/B104",
    //             txt: "B104_歷年申報資料明細查詢",
    //           },
    //           { href: "/BackStage/PDIS/B105", txt: "B105_各機關申報狀態查詢" },
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "D報表產製作業",
    //     child: [
    //       {
    //         href: "",
    //         txt: "D1各類報表產製作業",
    //         child: [
    //           { href: "/BackStage/PDIS/D101", txt: "D101_應申報人員" },
    //           { href: "/BackStage/PDIS/D103", txt: "D103_N日後逾期申報人員表" },
    //           { href: "/BackStage/PDIS/D106", txt: "D106_公職人員抽籤名單" },
    //           {
    //             href: "/BackStage/PDIS/D107",
    //             txt: "D107_公職人員財產申報人數及抽查比例統計表",
    //           },
    //           {
    //             href: "/BackStage/PDIS/D108",
    //             txt: "D108_財產申報案件管理一覽表",
    //           },
    //           {
    //             href: "/BackStage/PDIS/D110",
    //             txt: "D110_自然人憑證使用人數統計(月報表)",
    //           },
    //           { href: "/BackStage/PDIS/D111", txt: "D111_授權狀況一覽表" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "D2異常資料管理報表",
    //         child: [
    //           {
    //             href: "/BackStage/PDIS/D201",
    //             txt: "D201_申報類別勾選錯誤名單",
    //           },
    //           {
    //             href: "/BackStage/PDIS/D202",
    //             txt: "D202_卸離職/解除代理(兼任)申報日與卸離職日不符名單",
    //           },
    //           {
    //             href: "/BackStage/PDIS/D203",
    //             txt: "D203_申報日非於申報期間名單",
    //           },
    //           {
    //             href: "/BackStage/PDIS/D204",
    //             txt: "D204_一年以上不須申報人員名單",
    //           },
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "F抽籤審核",
    //     child: [
    //       {
    //         href: "",
    //         txt: "F1實質審查抽籤",
    //         child: [
    //           { href: "/BackStage/PDIS/F101", txt: "F101_抽籤作業" },
    //           { href: "/BackStage/PDIS/F102", txt: "F102_中籤名單維護" },
    //           { href: "/BackStage/PDIS/F103", txt: "F103_抽籤歷程查詢" },
    //           { href: "/BackStage/PDIS/F104", txt: "F104_其他抽籤人員匯入" },
    //           { href: "/BackStage/PDIS/F105", txt: "F105_抽籤名單匯入" },
    //           { href: "/BackStage/PDIS/F106", txt: "F106_各年度抽籤名單查詢作業" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "F2實質審核",
    //         child: [
    //           {
    //             href: "/BackStage/PDIS/F201",
    //             txt: "F201_財產申報資料審核作業",
    //           },
    //           {
    //             href: "/BackStage/PDIS/F202",
    //             txt: "F202_前後年度申報財產比對",
    //           },
    //           { href: "/BackStage/PDIS/F203", txt: "F203_實質審核誤差值設定" },
    //           {
    //             href: "/BackStage/PDIS/F204",
    //             txt: "F204_財稅資料查詢(含所得及財產)",
    //           },
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "M授權管理",
    //     child: [
    //       { href: "/BackStage/PDIS/M101", txt: "M101_查調(授權)名單管理" },
    //       { href: "/BackStage/PDIS/M102", txt: "M102_查調(授權)名單彙整" },
    //       { href: "/BackStage/PDIS/M103", txt: "M103_查調(授權)名單匯入平臺" },
    //       { href: "/BackStage/PDIS/M104", txt: "M104_授權時段管理" },
    //       { href: "/BackStage/PDIS/M105", txt: "M105_授權查調財產資料查詢" },
    //       { href: "/BackStage/PDIS/M106", txt: "M106_取消持續授權" },
    //     ],
    //   },
    //   {
    //     href: "",
    //     txt: "S系統管理",
    //     child: [
    //       {
    //         href: "",
    //         txt: "S1代碼維護",
    //         child: [{ href: "/BackStage/PDIS/S101", txt: "S101_代碼維護" }],
    //       },
    //       {
    //         href: "",
    //         txt: "S2系統功能表維護",
    //         child: [
    //           {
    //             href: "/BackStage/PDIS/S201",
    //             txt: "S201_系統功能目錄階層維護",
    //           },
    //           { href: "/BackStage/PDIS/S202", txt: "S202_系統程式維護" },
    //           { href: "/BackStage/PDIS/S203", txt: "S203_群組維護" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "S3使用者帳號密碼維護",
    //         child: [
    //           { href: "/BackStage/PDIS/S301", txt: "S301_使用者帳號維護" },
    //           { href: "/BackStage/PDIS/S302", txt: "S302_使用者密碼變更" },
    //           { href: "/BackStage/PDIS/S303", txt: "S303_忘記密碼" },
    //           { href: "/BackStage/PDIS/S304", txt: "S304_服務機關資料維護" },
    //           { href: "/BackStage/PDIS/S305", txt: "S305_政風單位資料維護" },
    //           { href: "/BackStage/PDIS/S306", txt: "S306_申請密碼" },
    //         ],
    //       },
    //       {
    //         href: "",
    //         txt: "S4系統資訊維護",
    //         child: [
    //           { href: "/BackStage/PDIS/S401", txt: "S401_年度假日管理" },
    //           { href: "/BackStage/PDIS/S402", txt: "S402_公告維護" },
    //           { href: "/BackStage/PDIS/S404", txt: "S404_電子郵件通知設定" },
    //           { href: "/BackStage/PDIS/S406", txt: "S406_常見問題維護" },
    //         ],
    //       },
    //       // {
    //       //   href:"" , txt:"S5系統排程維護",
    //       //   child:[
    //       //     {href:"/BackStage/PDIS/S501" , txt:"S501_系統排程作業時程設定"},
    //       //     {href:"/BackStage/PDIS/S502" , txt:"S502_系統排程執行記錄查詢"},
    //       //   ]
    //       // },
    //       {
    //         href: "",
    //         txt: "S6系統記錄查詢",
    //         child: [
    //           {
    //             href: "/BackStage/PDIS/S601",
    //             txt: "S601_公職人員財產申報系統使用記錄查詢",
    //           },
    //           { href: "/BackStage/PDIS/S602", txt: "S602_後台使用記錄查詢" },
    //           { href: "/BackStage/PDIS/S603", txt: "S603_跨平台介接記錄查詢" },
    //         ],
    //       },
    //     ],
    //   },
    // ];

    //授權MENU
    if (this.loginInfo && this.loginInfo.roleSeq) {
      GetRoleAuthorizeMenu({
        ROLE_SEQ: this.loginInfo.roleSeq,
        ServiceUnit: this.parentData.ServiceUnit,
      }).then((rData) => {
        if (rData.returnObject.roleAuthorizeMenu) {
          this.menuItem = rData.returnObject.roleAuthorizeMenu;
          this.menuItem.forEach((x) => (x.isMobileClick = false));
          sessionStorage.setItem(
            "RoleAuthorizeMenu",
            JSON.stringify(rData.returnObject.roleAuthorizeMenu)
          );
        } else {
          sessionStorage.removeItem("RoleAuthorizeMenu");
          alert("查無選單授權設定");
          if (this.parentData.ServiceUnit == "CY") {
            this.$router.push({ path: "/BackStage/CY/Login" });
          } else if (this.parentData.ServiceUnit == "PDIS") {
            this.$router.push({ path: "/BackStage/PDIS/Login" });
          }
        }
      });
    }
  },
  methods: {
    resetDefaultTime: function () {
      if (this.parentData.ServiceUnit == "CY") {
        Timeout.methods.resetCYDefaultTime();
      } else {
        Timeout.methods.resetDefaultTime();
      }
    },
    btnMbClick: function (item, index) {
      item.isMobileClick = !item.isMobileClick;
      //array物件重新監聽
      this.menuItem.splice(index, 1, item);
    },
  },
};
export default vm;
</script>

<style scoped>
.moreUl li {
  color: #117873;
  padding: 10px;
  font-weight: normal;
}
.hasSecond a.curent .sub-arrow {
  border-color: #117873 transparent transparent transparent;
}
.sm-blue ul a {
  padding: 0;
}
@media all and (min-width: 1000px) {
  .hasSecond:hover .moreUl {
    display: block;
  }
  .moreUl li:hover ul {
    display: block;
  }
  #menu .sm-blue .moreUl {
    width: auto;
    top: 50px;
    left: 0px;
    margin-left: 0px;
    margin-top: 0px;
    min-width: 220px;
    max-width: 30em;
    z-index: 9999;
  }
}
@media all and (max-width: 1000px) {
  .moreUlMbClick .moreUl {
    display: block;
  }
  .moreUlMbClick .sub-arrow::before {
    content: "-";
  }
  .moreUlMbClick .sub-arrow {
    top: auto;
  }
}
</style>
